import {useQuery} from "@tanstack/react-query";
import {type GetNewsParams, getNewsService} from "./news.service";
import type {Article} from "./news.types";

export const NEWS_QUERY_KEY = "news" as const;

export const useNews = (params: GetNewsParams = {}) => {
  const query = useQuery<Article[], Error>({
    queryKey: [NEWS_QUERY_KEY, params.limit ?? null, params.page ?? null],
    queryFn: () => getNewsService(params),
    staleTime: 60_000,
  });
  return {
    articles: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
